import NoWrapTableCell from 'Components/NoWrapTableCell'
import { datetimeFormatter } from 'Util/formatters'
import InfoIcon from '@mui/icons-material/Info'
import { Chip, type ChipProps, IconButton, Tooltip } from '@mui/material'
import { t } from 'ttag'

enum ActivityStatus {
  ACTIVE = 'ACTIVE',
  PASSIVE = 'PASSIVE'
}

interface ActivityChipProps {
  active: boolean
  activity_end_date?: Date | null
}

export default function ActivityChipTableCell({
  active,
  activity_end_date
}: Readonly<ActivityChipProps>) {
  const chipPropsMapping: Record<ActivityStatus, Pick<ChipProps, 'color' | 'label'>> = {
    [ActivityStatus.ACTIVE]: { color: 'success', label: t`Active` },
    [ActivityStatus.PASSIVE]: { color: 'default', label: t`Passive` }
  }

  function getActivityKey(status: boolean): keyof typeof chipPropsMapping {
    return status ? ActivityStatus.ACTIVE : ActivityStatus.PASSIVE
  }

  function getChipPropsByActivity(status: boolean) {
    return chipPropsMapping[getActivityKey(status)]
  }

  return (
    <NoWrapTableCell title={getActivityKey(active)}>
      <Chip size="small" {...getChipPropsByActivity(active)} />
      {activity_end_date &&
        active &&
        (() => {
          const activityEndsText = t`Activity ends`
          return (
            <Tooltip
              title={`${activityEndsText} ${datetimeFormatter(activity_end_date)}`}
              placement="top"
            >
              <IconButton sx={{ py: 0 }}>
                <InfoIcon color="error" />
              </IconButton>
            </Tooltip>
          )
        })()}
    </NoWrapTableCell>
  )
}
